import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import { api } from "@/lib/api";

export const SettingsContext = createContext({});
export const useSettings = () => useContext(SettingsContext);

export default function SiteLayout() {
  const [settings, setSettings] = useState({});
  const location = useLocation();

  useEffect(() => {
    // Settings only — SEO title & meta are managed per-page via <PageSEO />
    api.get("/site/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <SettingsContext.Provider value={settings}>
      <div className="min-h-screen flex flex-col relative">
        <div className="rr-global-grid" aria-hidden="true" />
        <Navbar />
        <main className="flex-1 pt-20 relative z-[2]">
          <Outlet />
        </main>
        <div className="relative z-[2]">
          <Footer settings={settings} />
        </div>
        <WhatsAppButton phone={settings.whatsapp || "917887618891"} />
      </div>
    </SettingsContext.Provider>
  );
}
